import { render, staticRenderFns } from "./contract-kline.vue?vue&type=template&id=c6120a32&"
import script from "./contract-kline.vue?vue&type=script&lang=js&"
export * from "./contract-kline.vue?vue&type=script&lang=js&"
import style0 from "./contract-kline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports